import { useMutation, useQuery } from 'react-query';

import { ErrorResponse } from 'api/types/errors';
import {
  getCurrentUserOrganizationsMemberships,
  getCurrentUserOrganizationsMembershipById,
  cancelCurrentUserOrganizationsMembershipById,
  getCurrentUserOrganizationAccessStatus
} from 'api/services/users/memberships';
import { OutgoingMembershipDto } from 'api/dtos/memberships/products';

export function useGetCurrentUserOrganizationsMemberships({
  enabled
}: {
  enabled: boolean;
}) {
  return useQuery<OutgoingMembershipDto[], ErrorResponse>(
    ['userOrganizationsMemberships'],
    () => getCurrentUserOrganizationsMemberships(),
    {
      enabled
    }
  );
}

export function useGetCurrentUserOrganizationsMembershipById({
  membershipId,
  enabled
}: {
  membershipId: string;
  enabled: boolean;
}) {
  return useQuery<OutgoingMembershipDto, ErrorResponse>(
    ['userOrganizationsMemberships', membershipId],
    () => getCurrentUserOrganizationsMembershipById(membershipId),
    {
      enabled
    }
  );
}

export function useCancelCurrentUserOrganizationsMembershipById() {
  return useMutation<{ success: boolean }, ErrorResponse, string>(
    cancelCurrentUserOrganizationsMembershipById
  );
}

export function useGetCurrentUserOrganizationAccessStatus({
  organizationId,
  enabled
}: {
  organizationId: string;
  enabled?: boolean;
}) {
  return useQuery<{ success: boolean }, ErrorResponse>(
    ['userOrganizationAccessStatus', organizationId],
    () => getCurrentUserOrganizationAccessStatus(organizationId),
    {
      enabled: !!organizationId && enabled,
      retry: false
    }
  );
}
